const ComedyMovies = [
  {
    title: 'Free Guy',
    img: 'free_guy.jpeg',
    synopsis: "A bank teller discovers that he's actually an NPC inside a brutal, open world video game.",
    score: 7.1,
  },
  {
    title: 'Minions',
    img: 'minions.jpeg',
    synopsis: 'Minions Stuart, Kevin, and Bob are recruited by Scarlet Overkill, a supervillain who, alongside her inventor husband Herb, hatches a plot to take over the world.',
    score: 6.4,
  },
  {
    title: 'Superbad',
    img: 'superbad.jpeg',
    synopsis: 'An unlikely trio is found struggling to concel their antics.',
    score: 8,
  },
];

export default ComedyMovies;
